import React, { FC, useState } from 'react'
import { Alert, Button, Card, Col, Form, Modal, Row } from 'react-bootstrap'
import DataTable from 'react-data-table-component'
import { IconContext } from 'react-icons'
import { useDispatch, useSelector } from 'react-redux'
import ICatClientes from '../../Interfaces/Catalogos/ICatClientes'
import { RootState } from '../../store/store'
import { BsEraserFill, BsFillPencilFill, BsFillTrashFill, BsSave } from 'react-icons/bs'
import DSCatClientes from '../../Services/Catalogos/CatClientes.Services'
import { updateCatClientes, deleteCatClientes } from '../../store/features/Catalogos/CatClientesSlice'

interface IProps {}

export const CatClientes: FC<IProps> = (props) => {
  const dispatch = useDispatch()
  const CatClientes = useSelector((state: RootState) => state.CatClientes.CatClientes)
  const [showCatClientesDialog, setShowCatClientesDialog] = useState(false)
  const [deleteCatClientesDialog, setDeleteCatClientesDialog] = useState(false)
  const [IDCliente, setIDCliente] = useState(0)
  const [Cliente, setCliente] = useState('')
  const [Search, setSearch] = useState('')
  const columnsConcepts = [
    {
      name: 'id',
      width: '80px',
      selector: (row: ICatClientes) => row.id,
      sortable: true,
    },
    {
      name: 'Cliente',
      width: '450px',
      selector: (row: ICatClientes) => row.cliente,
      sortable: true,
    },
    {
      name: 'Editar',
      width: '100px',
      cell: (row: ICatClientes) => (
        <div
          style={{ textAlign: 'center', cursor: 'pointer' }}
          onClick={() => {
            showInfo(row)
          }}
        >
          <IconContext.Provider value={{ color: 'blue', size: '21px' }}>
            <BsFillPencilFill />
          </IconContext.Provider>
        </div>
      ),
      sortable: true,
    },
    {
      name: 'Elimina',
      width: '100px',
      cell: (row: ICatClientes) => (
        <div
          style={{ textAlign: 'center', cursor: 'pointer' }}
          onClick={() => {
            confirmDelete(row)
          }}
        >
          <IconContext.Provider value={{ color: 'red', size: '21px' }}>
            <BsFillTrashFill />
          </IconContext.Provider>
        </div>
      ),
      sortable: true,
    },
  ]

  const showInfo = (data: ICatClientes) => {
    setIDCliente(data.id)
    setCliente(data.cliente)
    setShowCatClientesDialog(true)
  }

  const confirmDelete = (data: ICatClientes) => {
    setIDCliente(data.id)
    setCliente(data.cliente)
    setDeleteCatClientesDialog(true)
  }

  const deleteInfo = () => {
    DSCatClientes.Delete(IDCliente)
      .then((response) => {
        dispatch(deleteCatClientes(IDCliente))
      })
      .catch((e: Error) => {})
    setDeleteCatClientesDialog(false)
  }

  const clearForm = () => {
    setIDCliente(0)
    setCliente('')
  }

  const saveInfo = () => {
    const data: ICatClientes = {
      id: IDCliente,
      cliente: Cliente,
      activo: 1,
    }
    DSCatClientes.Append(data)
      .then((response) => {
        dispatch(updateCatClientes(response.data))
      })
      .catch((e: Error) => {})
    setShowCatClientesDialog(false)
  }

  return (
    <div>
      <Row>
        <Col xs={12}>
          <Card style={{}}>
            <Card.Body>
              <Card.Title style={{ textAlign: 'left' }}>
                <Alert variant='primary'>Clientes</Alert>
              </Card.Title>
              <Row>
                <Col xs={12}>
                  <Form.Control
                    type='text'
                    size='sm'
                    placeholder='Search...'
                    onChange={(e) => {
                      setSearch(e.target.value)
                    }}
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={12}>
                  <DataTable
                    noHeader
                    defaultSortFieldId={'id'}
                    defaultSortAsc={true}
                    striped={true}
                    dense={true}
                    paginationPerPage={10}
                    pagination
                    highlightOnHover
                    columns={columnsConcepts}
                    data={CatClientes.filter(function (row: ICatClientes) {
                      return row.cliente.includes(Search)
                    })}
                    pointerOnHover
                  />
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Modal
        show={showCatClientesDialog}
        onHide={() => {
          setShowCatClientesDialog(false)
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Catalogo: Clientes</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col xs={3}>No cliente</Col>
            <Col xs={2} style={{ textAlign: 'right' }}>
              <Form.Control type='text' id='IDCliente' value={IDCliente} disabled size='sm' />
            </Col>
            <Col xs={1} style={{ textAlign: 'left' }}>
              <Button
                size='sm'
                variant='white'
                onClick={() => {
                  clearForm()
                }}
              >
                <IconContext.Provider value={{ color: 'orange', size: '25px' }}>
                  <BsEraserFill />
                </IconContext.Provider>
              </Button>
            </Col>
          </Row>
          <br />
          <Row>
            <Col xs={2}>Cliente</Col>
            <Col xs={10}>
              <Form.Control
                type='text'
                id='Cliente'
                value={Cliente}
                size='sm'
                onChange={(e) => {
                  setCliente(e.target.value)
                }}
              />
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Row>
            <Col xs={2}></Col>
            <Col xs={3}>&nbsp;</Col>
            <Col xs={3}>
              <Button
                variant='primary'
                onClick={() => {
                  saveInfo()
                }}
              >
                Guarda
              </Button>
            </Col>
          </Row>
        </Modal.Footer>
      </Modal>
      <Modal
        show={deleteCatClientesDialog}
        onHide={() => {
          setDeleteCatClientesDialog(false)
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Catalogo: Clientes</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <br />
          <Row>
            <Col xs={12}>
              <Alert variant='warning'>
                ¿Esta seguro de que desea eliminar el cliente: <br />
                <span style={{ fontWeight: 'bold', fontSize: '20px' }}>{Cliente}</span>?
              </Alert>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Row>
            <Col xs={2}></Col>
            <Col xs={3}>&nbsp;</Col>
            <Col xs={3}>
              <Button
                variant='danger'
                onClick={() => {
                  deleteInfo()
                }}
              >
                Elimina
              </Button>
            </Col>
          </Row>
        </Modal.Footer>
      </Modal>
    </div>
  )
}
